export function getErrorMessage(error: any): string {
  return error?.response?.data?.detail || error?.message || "An unexpected error occurred";
}

export function isConflictError(error: any): boolean {
  return error?.response?.status === 409;
}
